module.exports = __webpack_public_path__ + "img/neigenfink.c5760135.jpg";